import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { OrdersState } from 'src/app/core/states/orders/orders.state';

@Component({
    selector: 'app-pax-payment-status',
    templateUrl: './pax-payment-status.component.html',
    styleUrls: ['./pax-payment-status.component.scss'],
    standalone: false
})
export class PaxPaymentStatusComponent {
  displayStatus?: string;
  @Output() finished: EventEmitter<any> = new EventEmitter();
  readonly onDestroy$ = new Subject<void>();

  constructor(readonly store: Store) {}

  ngOnInit() {
    this.displayStatus = 'Inväntar terminalen';
    this.store
      .select(OrdersState.status)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((status) => {
        setTimeout(() => {
          this.displayStatus =
            status.displayData?.[status.displayData.length - 1]?.description ??
            'Inväntar terminalen';

          if (status.transCancelled) {
            /* Emit output cancelled */
            this.finished.emit({ cancelled: true });
          } else if (status.transApproved) {
            /* Emit output approved */
            this.finished.emit({ approved: true });
            this.displayStatus = 'Betalning godkänd';
          } else if (status.transDeclined) {
            /* Emit output declined */
            this.displayStatus = 'Betalningen misslyckades';
            this.finished.emit({ declined: true });
          } else if (status.transEnded) {
            /* Emit output ended */
            this.displayStatus = 'Avslutar betalningssession';
            this.finished.emit({ ended: true });
          }

          if (status.errorText === 'no connection') {
            this.finished.emit({ noConnection: true });
          }
        });
      });
  }

  ngOnDestroy(): void {
    this.displayStatus = undefined;
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
